<template>
  <div class="mv-bg-main">
    <el-row>
      <el-col :span="24">
        <el-card shadow="always">
          <div slot="header" class="clearfix">
            <span>查询条件</span>
          </div>
          <el-form
            :inline="true"
            :model="formInline"
            ref="searchForm"
            label-width="100px"
            class="demo-form-inline"
          >
            <el-form-item label="业务系统" prop="sysId">
              <el-select
                v-model="formInline.sysId"
                placeholder="请选择业务系统"
                clearable
                filterable
              >
                <el-option
                  v-for="(item, index) in sysData"
                  :key="index"
                  :label="item.systemName"
                  :value="item.systemId"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="客户名称" prop="custId">
              <el-select @change="changeCust" v-model="formInline.custId"  clearable filterable placeholder="请选择客户名称">
                <el-option :label="item.custName" :value="item.custId" v-for="(item, $index) in cusData" :key="$index"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="合同名称" prop="conName">
              <el-select
                v-model="formInline.conName"
                placeholder="请选择合同名称"
                clearable
              >
                <el-option
                  v-for="item in conData"
                  :key="item.contractId"
                  :label="item.contractName"
                  :value="item.contractId"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="创建时间" prop="createTime">
              <el-date-picker
                v-model="formInline.createTime"
                type="daterange"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              ></el-date-picker>
            </el-form-item>
            <el-form-item class="float-r">
              <el-button size="small" @click="onReset('searchForm')">重置</el-button>
              <el-button size="small" type="primary" @click="onSearch()">查询</el-button>
            </el-form-item>
          </el-form>
        </el-card>
      </el-col>
    </el-row>
    <div style="margin-top:20px"></div>
    <el-row>
      <el-col :span="24">
        <el-card class="box-card" shadow="always">
          <div slot="header" class="clearfix">
            <span>查询结果</span>
            <div class="mv-list-buttons float-r">
              <el-button
                size="small"
                type="primary"
                icon="el-icon-plus"
                title="新增供应商合同"
                @click="handleAdd"
              ></el-button>
            </div>
          </div>
          <el-row>
            <el-table
              :data="tableList"
              :fit="true"
              style="width: 100%"
            >
              <!-- <el-table-column type="selection" width="55"></el-table-column> -->
              <el-table-column prop="sysName" :show-overflow-tooltip="tooltip" label="业务系统"></el-table-column>
              <el-table-column prop="custName" :show-overflow-tooltip="tooltip" label="客户名称">
                <template slot-scope="scope">
                  <span class="link" @click="detail(scope.$index, scope.row)">{{ scope.row.custName }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="contractName" :show-overflow-tooltip="tooltip" label="合同名称"></el-table-column>
              <!-- <el-table-column
                prop="state"
                :show-overflow-tooltip="tooltip"
                :formatter="maintenanceStatus"
                label="供应商状态"
              ></el-table-column> -->
              <!-- <el-table-column prop="supContactName" :show-overflow-tooltip="tooltip" label="合同编号"></el-table-column> -->
              <el-table-column prop="transferName" :show-overflow-tooltip="tooltip" label="打款名称"></el-table-column>
              <el-table-column
                prop="contractAmount"
                width="200"
                :show-overflow-tooltip="tooltip"
                label="合同金额(元)"
              ></el-table-column>
              <el-table-column prop="transferAmount" :show-overflow-tooltip="tooltip" label="打款金额"></el-table-column>
              <el-table-column prop="contractEffective" :show-overflow-tooltip="tooltip" label="合同有效期"></el-table-column>
              <el-table-column prop="abuName" :show-overflow-tooltip="tooltip" label="商务经理"></el-table-column>
              <el-table-column prop="createTime" :show-overflow-tooltip="tooltip" label="创建时间"></el-table-column>
              <el-table-column label="操作" width="100" fixed="right">
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    @click="handleEdit(scope.$index, scope.row)"
                  >编辑</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-row>
          <div class="page-navigation">
            <el-pagination
              background
              :current-page.sync="page.num"
              :page-sizes="[10, 20, 30, 40, 50]"
              :page-size="page.size"
              layout="total, sizes, prev, pager, next"
              :total="totalRows"
              @size-change="pageSizeChange"
              @current-change="pageCurrentChange"
            ></el-pagination>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <el-dialog  title="合同信息维护" @close="closeContract" width="1050px" center :modal-append-to-body='false' :visible.sync="contractDialog">
      <el-form :model="contractInfo" :rules="rule" ref="contractInfo" label-width="120px" >
        <el-tabs v-model="activeName" >
          <el-tab-pane label="基本信息" name="first">
            <el-form-item label="业务系统" prop="sysId">
              <el-select
                v-model="contractInfo.sysId"
                placeholder="请选择业务系统"
                style="width: 100%;"
                clearable
                filterable
              >
                <el-option
                  v-for="(item, index) in sysData"
                  :key="index"
                  :label="item.systemName"
                  :value="item.systemId"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="客户名称" prop="custName">
              <el-select style="width: 100%;" v-model="contractInfo.custName"  clearable  placeholder="请选择客户名称">
                <el-option :label="item.custName" :value="item.custId" v-for="(item, $index) in cusData" :key="$index"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="合同编号" prop="numberContract"   >
              <el-input style="width: 100%;"  maxlength="60" clearable v-model="contractInfo.numberContract" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="合同名称" prop="nameContract"  >
              <el-input style="width: 100%;"  maxlength="60" clearable v-model="contractInfo.nameContract" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="打款名称" prop="paymentName"   >
              <el-input style="width: 100%;"   maxlength="60" clearable v-model="contractInfo.paymentName" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="合同余额" prop="contractBalance" >
              <el-input style="width: 100%;"    maxlength="30" clearable v-model="contractInfo.contractBalance" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="打款余额" prop="transferAmount" >
              <el-input style="width: 100%;"    maxlength="30" clearable v-model="contractInfo.transferAmount" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="合同有效期" prop="createTime">
              <el-date-picker
                style="width: 100%;"
                v-model="contractInfo.createTime"
                type="daterange"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              ></el-date-picker>
            </el-form-item>
            <div style="textAlign: center;" >
              <el-button @click="contractDialog=false">关 闭</el-button>
              <el-button type="primary" v-if="add" @click="saveinfoEssential('contractInfo')">确 定</el-button>
              <el-button type="primary" v-if="!add" @click="saveinfoEditEssential('contractInfo')">确 定</el-button>
            </div>
          </el-tab-pane>
          <el-tab-pane label="详情信息" :disabled="tabDisabled" name="second">
            <el-form-item label="对方签约人"  >
              <el-input style="width: 100%;"   maxlength="30" clearable v-model="contractInfo.superContractor" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="公司签约人"  >
              <el-input style="width: 100%;"   maxlength="30" clearable v-model="contractInfo.companyContractor" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="合同附件" prop="contractFiles">
              <el-upload
                class="upload-demo"
                :action="uploadFile"
                :on-preview="handlePreview"
                :on-success = "success"
                :on-remove="handleRemove"
                :beforeUpload="beforeAvatarUpload"
                :file-list="contractInfo.contractFiles"
                :headers="headers"
                multiple
                accept="application/pdf"
              >
                <!-- :file-list="editMaintenance.contractFiles" -->
                <el-button size="small" plain type="primary">点击上传</el-button>
                <div slot="tip" class="el-upload__tip">只能上传pdf文件，且不超过20M</div>
              </el-upload>
            </el-form-item>
            <div style="textAlign: center;margin:20px 0">
              <el-button @click="contractDialog=false">关 闭</el-button>
              <el-button
                type="primary"
                @click="saveDetail('contractInfo')"
              >确 定</el-button>
            </div>
          </el-tab-pane>
          <el-tab-pane label="产品信息" :disabled="tabDisabled" name="third">
            <el-form-item
              label="新增产品信息">
              <el-button
              size="small"
              type="primary"
              icon="el-icon-plus"
              style="margin-left: 10px;"
              title="新增产品信息"
              plain
              @click="addExtField"
            ></el-button>
            </el-form-item>
            <div
              v-for="(item, index) in contractInfo.extFieldList"
              class="clearfix"
              :key="index">
              <el-col :span="7">
                <el-form-item
                  label="产品名称"
                  :prop="'extFieldList.'+ index + '.name'"
                >
                  <el-select style="width: 100%;"  v-model="item.prodId"   filterable placeholder="请选择产品名称">
                    <el-option :label="op.prodName" @click.native="changePro(item, index)" :value="op.prodId" v-for="(op, $index) in proData" :key="$index"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="7">
                <el-form-item
                  label="成交数量"
                  :prop="'extFieldList.'+ index + 'value'"
                >
                  <el-input-number @change="addNum" v-model="item.orderCount" controls-position="right"  :min="0" :max="item.max"></el-input-number>
                </el-form-item>
              </el-col>
              <el-col :span="7">
                <el-form-item
                  label="实际成交价"
                >
                  <el-input :disabled="item.disabled" maxlength="10" @input="changePrice" v-model="item.actualOrderAmount" placeholder></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="2" :offset="1">
                <el-button
                  class="float-r"
                  size="small"
                  icon="el-icon-delete"
                  @click.prevent="removeExtField(item)"
                  title="删除"
                ></el-button>
              </el-col>
            </div>
            <div>
              <el-col :span="8">
                <el-form-item
                  label="">
                  合计
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                  label="">
                  {{totalNum}}
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                  label="">
                  {{totalPric}}
                </el-form-item>
              </el-col>
            </div>
            <div style="textAlign: center;margin:20px 0">
              <el-button @click="contractDialog = false">关 闭</el-button>
              <el-button
                type="primary"
                @click="saveProduct('contractInfo')"
              >确 定</el-button>
            </div>
          </el-tab-pane>
          <!-- <el-tab-pane label="应收账款" name="fourth">
            <el-form-item
              label="新增应收账款">
              <el-button
              size="small"
              type="primary"
              icon="el-icon-plus"
              style="margin-left: 10px;"
              title="新增应收账款"
              plain
              @click="addExtField"
            ></el-button>
            </el-form-item>
            <div class="clearfix" style="text-align: center;">
              <p style="float: left;width: 120px; margin-left: 20px; margin-bottom: 20px;">款项内容</p>
              <p style="float: left;width: 120px; margin-left: 20px;">收款条件</p>
              <p style="float: left;width: 120px; margin-left: 20px;">违约责任</p>
              <p style="float: left;width: 120px; margin-left: 20px;">应收日期</p>
              <p style="float: left;width: 120px; margin-left: 20px;">应收金额</p>
              <p style="float: left;width: 120px; margin-left: 20px;">收款状态</p>
            </div>
              <div
                v-for="(item, index) in contractInfo.extFieldList"
                class="clearfix"
                :key="index">
                <el-input style="float: left; width: 120px; margin-left: 20px;margin-bottom: 20px;" v-model="item.name" placeholder></el-input>
                <el-input style="float: left;width: 120px;margin-left: 20px;" v-model="item.value" placeholder></el-input>
                <el-input style="float: left;width: 120px; margin-left: 20px;" v-model="item.value"></el-input>
                <el-date-picker
                      v-model="item.value1"
                      type="date"
                      style="float: left;width: 120px; margin-left: 20px;"
                      placeholder="选择日期">
                    </el-date-picker>
                <el-input style="float: left;width: 120px; margin-left: 20px;" v-model="item.value" ></el-input>
                <el-input style="float: left;width: 120px; margin-left: 20px;" v-model="item.value" ></el-input>
                <el-button
                    class="float-r"
                    size="small"
                    icon="el-icon-delete"
                    @click.prevent="removeExtField(item)"
                    title="删除"
                  ></el-button>
              </div>
              <div>
                <el-col :span="8">
                  <el-form-item
                    label="">
                    合计
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item
                    label="">
                    合计
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item
                    label="">
                    合计
                  </el-form-item>
                </el-col>
              </div>
          </el-tab-pane> -->
        </el-tabs>
      </el-form>
    </el-dialog>
    <el-dialog  title="客户合同信息详情" @close="closeDeatilContract" width="1050px" center :modal-append-to-body='false' :visible.sync="contractDetailDialog">
      <el-form :model="contractDetailInfo" :rules="rule" ref="contractDetailInfo" label-width="120px" >
        <el-tabs v-model="activeDetailName" >
          <el-tab-pane label="基本信息" name="99">
            <el-form-item label="业务系统" >
              <el-select
                v-model="contractDetailInfo.sysId"
                placeholder="请选择业务系统"
                disabled
                style="width: 100%;"
                clearable
                filterable
              >
                <el-option
                  v-for="(item, index) in sysData"
                  :key="index"
                  :label="item.systemName"
                  :value="item.systemId"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="客户名称" >
              <el-select disabled style="width: 100%;" v-model="contractDetailInfo.custName"  clearable filterable placeholder="请选择客户名称">
                <el-option :label="item.custName" :value="item.custId" v-for="(item, $index) in cusData" :key="$index"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="合同编号" prop="numberContract"   >
              <el-input style="width: 100%;" disabled maxlength="60" clearable v-model="contractDetailInfo.numberContract" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="合同名称"  prop="nameContract"  >
              <el-input style="width: 100%;" disabled maxlength="60" clearable v-model="contractDetailInfo.nameContract" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="打款名称" prop="paymentName"   >
              <el-input style="width: 100%;" disabled  maxlength="60" clearable v-model="contractDetailInfo.paymentName" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="合同余额"  prop="contractBalance">
              <el-input style="width: 100%;" disabled  maxlength="30" clearable v-model="contractDetailInfo.contractBalance" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="打款余额" prop="transferAmount" >
              <el-input style="width: 100%;" disabled  maxlength="30" clearable v-model="contractDetailInfo.transferAmount" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="合同有效期" prop="createTime">
              <el-date-picker
                v-model="contractDetailInfo.createTime"
                type="daterange"
                disabled
                style="width: 100%;"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              ></el-date-picker>
            </el-form-item>
          </el-tab-pane>
          <el-tab-pane label="详情信息" name="second">
            <el-form-item label="对方签约人"  >
              <el-input style="width: 100%;" disabled  maxlength="30" clearable v-model="contractDetailInfo.superContractor" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="公司签约人"  >
              <el-input style="width: 100%;" disabled maxlength="30" clearable v-model="contractDetailInfo.companyContractor" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="合同附件" prop="contractFiles">
              <el-upload
                class="upload-demo"
                :action="uploadFile"
                :on-preview="handlePreview"
                :on-success = "success"
                :on-remove="handleRemove"
                :beforeUpload="beforeAvatarUpload"
                :file-list="contractDetailInfo.contractFiles"
                :headers="headers"
                multiple
                accept="application/pdf"
              >
                <!-- :file-list="editMaintenance.contractFiles" -->
                <!-- <el-button size="small" plain type="primary">点击上传</el-button> -->
                <!-- <div slot="tip" class="el-upload__tip">只能上传pdf文件，且不超过20M</div> -->
              </el-upload>
            </el-form-item>
          </el-tab-pane>
          <el-tab-pane label="产品信息" name="third">
            <!-- <el-form-item
              label="新增产品信息">
              <el-button
              size="small"
              type="primary"
              icon="el-icon-plus"
              style="margin-left: 10px;"
              title="新增产品信息"
              plain
              @click="addExtField"
            ></el-button>
            </el-form-item> -->
              <div
                v-for="(item, index) in contractDetailInfo.extFieldList"
                class="clearfix"
                :key="index">
                <el-col :span="7">
                  <el-form-item
                    label="产品名称"
                    :prop="'extFieldList.'+ index + '.name'"
                  >
                    <el-select disabled style="width: 100%;"  v-model="item.prodId"  clearable filterable placeholder="请选择产品名称">
                      <el-option :label="op.prodName" @click.native="changePro(item, index)" :value="op.prodId" v-for="(op, $index) in proData" :key="$index"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="7">
                  <el-form-item
                    label="成交数量"
                    :prop="'extFieldList.'+ index + 'value'"
                  >
                    <el-input disabled  v-model="item.orderCount" ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="7">
                  <el-form-item
                    label="实际成交价"
                  >
                    <el-input maxlength="10" disabled v-model="item.actualOrderAmount" placeholder></el-input>
                  </el-form-item>
                </el-col>
                <!-- <el-col :span="2" :offset="1">
                  <el-button
                    class="float-r"
                    size="small"
                    icon="el-icon-delete"
                    @click.prevent="removeExtField(item)"
                    title="删除"
                  ></el-button>
                </el-col> -->
              </div>
              <!-- <div>
                <el-col :span="8">
                  <el-form-item
                    label="">
                    合计
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item
                    label="">
                    {{totalNum}}
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item
                    label="">
                    {{totalPric}}
                  </el-form-item>
                </el-col>
              </div>
              <div style="textAlign: center;margin:20px 0">
                <el-button @click="contractDialog = false">取消</el-button>
                <el-button
                  type="primary"
                  @click="saveProduct('contractInfo')"
                >确 定</el-button>
              </div> -->
          </el-tab-pane>
          <!-- <el-tab-pane label="应收账款" name="fourth">
            <el-form-item
              label="新增应收账款">
              <el-button
              size="small"
              type="primary"
              icon="el-icon-plus"
              style="margin-left: 10px;"
              title="新增应收账款"
              plain
              @click="addExtField"
            ></el-button>
            </el-form-item>
            <div class="clearfix" style="text-align: center;">
              <p style="float: left;width: 120px; margin-left: 20px; margin-bottom: 20px;">款项内容</p>
              <p style="float: left;width: 120px; margin-left: 20px;">收款条件</p>
              <p style="float: left;width: 120px; margin-left: 20px;">违约责任</p>
              <p style="float: left;width: 120px; margin-left: 20px;">应收日期</p>
              <p style="float: left;width: 120px; margin-left: 20px;">应收金额</p>
              <p style="float: left;width: 120px; margin-left: 20px;">收款状态</p>
            </div>
              <div
                v-for="(item, index) in contractInfo.extFieldList"
                class="clearfix"
                :key="index">
                <el-input style="float: left; width: 120px; margin-left: 20px;margin-bottom: 20px;" v-model="item.name" placeholder></el-input>
                <el-input style="float: left;width: 120px;margin-left: 20px;" v-model="item.value" placeholder></el-input>
                <el-input style="float: left;width: 120px; margin-left: 20px;" v-model="item.value"></el-input>
                <el-date-picker
                      v-model="item.value1"
                      type="date"
                      style="float: left;width: 120px; margin-left: 20px;"
                      placeholder="选择日期">
                    </el-date-picker>
                <el-input style="float: left;width: 120px; margin-left: 20px;" v-model="item.value" ></el-input>
                <el-input style="float: left;width: 120px; margin-left: 20px;" v-model="item.value" ></el-input>
                <el-button
                    class="float-r"
                    size="small"
                    icon="el-icon-delete"
                    @click.prevent="removeExtField(item)"
                    title="删除"
                  ></el-button>
              </div>
              <div>
                <el-col :span="8">
                  <el-form-item
                    label="">
                    合计
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item
                    label="">
                    合计
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item
                    label="">
                    合计
                  </el-form-item>
                </el-col>
              </div>
          </el-tab-pane> -->
        </el-tabs>
      </el-form>
    </el-dialog>
  </div>
</template>

<script >
export default {
  name: 'cusContract',
  data () {
    return {
      formInline: {
        sysId: '',
        custId: '',
        conName: '',
        createTime: ''
      },
      activeDetailName: '99',
      rule: {
        sysId: [
          {
            required: true,
            message: '请选择系统名称',
            trigger: ['blur', 'change']
          }
        ],
        custName: [
          {
            required: true,
            message: '请选择客户名称',
            trigger: ['blur', 'change']
          }
        ],
        contractBalance: [
          {
            validator: (rule, value, callback) => {
              if (value !== '') {
                console.log(value)
                if ((/^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/).test(value) === false) {
                  callback(new Error('请填写大于0的数字'))
                } else if ((/^[0-9]+(.[0-9]{1,2})?$/).test(value) === false) {
                  callback(new Error('请输入有效金额且小数点后面保留两位'))
                } else {
                  callback()
                }
              } else {
                callback(new Error('请填写大于0的数字'))
              }
            },
            trigger: ['blur', 'change']
          }
        ],
        transferAmount: [
          {
            validator: (rule, value, callback) => {
              if (value !== '') {
                console.log(value)
                if ((/^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/).test(value) === false) {
                  callback(new Error('请填写大于0的数字'))
                } else if ((/^[0-9]+(.[0-9]{1,2})?$/).test(value) === false) {
                  callback(new Error('请输入有效金额且小数点后面保留两位'))
                } else {
                  callback()
                }
              } else {
                callback(new Error('请填写大于0的数字'))
              }
            },
            trigger: ['blur', 'change']
          }
        ],
        actualOrderAmount: [{
          validator: (rule, value, callback) => {
            if (value !== '') {
              console.log(value)
              if ((/^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/).test(value) === false) {
                callback(new Error('请填写大于0的数字'))
              } else if ((/^[0-9]+(.[0-9]{1,2})?$/).test(value) === false) {
                callback(new Error('请输入有效金额且小数点后面保留两位'))
              } else {
                callback()
              }
            } else {
              callback(new Error('请填写大于0的数字'))
            }
          },
          trigger: ['blur', 'change']
        }]
      },
      contractDetailDialog: false,
      totalNum: '',
      totalPric: '',
      cusData: [],
      proData: [],
      headers: {
        mtk: localStorage.getItem('usermtk')
      },
      activeName: 'first',
      uploadFile: this.$API.fileUpload,
      contractDialog: false,
      tableList: [],
      title: '',
      add: true,
      contractDetailInfo: {
        sysId: '',
        supName: '',
        numberContract: '',
        transferAmount: '',
        contractId: '',
        nameContract: '',
        custName: '',
        paymentName: '',
        createTime: '',
        contractBalance: '',
        superContractor: '',
        extFieldList: [],
        paymentAmount: '',
        contractFiles: [],
        companyContractor: ''
      },
      contractInfo: {
        sysId: '',
        supName: '',
        custName: '',
        numberContract: '',
        transferAmount: '',
        contractId: '',
        nameContract: '',
        paymentName: '',
        createTime: '',
        contractBalance: '',
        superContractor: '',
        extFieldList: [],
        paymentAmount: '',
        contractFiles: [],
        companyContractor: ''
      },
      tabDisabled: true,
      page: {
        num: 1,
        sizeSmall: 10,
        size: 100
      },
      tooltip: true,
      totalRows: 0,
      conData: []
    }
  },
  computed: {
    sysData () {
      return this.$store.state.sysData
    }
  },
  methods: {
    /* 重置操作 */
    onReset (formName) {
      this.formInline = {
        sysId: '',
        custId: '',
        conName: '',
        createTime: ''
      }
      this.$refs[formName].resetFields()
    },
    // 每页显示多少条
    pageSizeChange (val) {
      this.page.sizeSmall = val
      this.page.num = 1
      this.query()
    },
    // 当前页选择
    pageCurrentChange (val) {
      this.page.num = val
      this.query()
    },
    success (response, file, fileList) {
      if (!response.resCode) {
        this.$router.push('/login')
      }
      if (response.resData.url) {
        console.log(response.resData)
        let op = {}
        op.name = response.resData.fileName
        op.url = response.resData.url
        this.contractInfo.contractFiles.push(op)
      }
    },
    handleRemove (file, fileList) {
      // 删除图片
      let url = file.url
      for (let i = 0; i < this.contractInfo.contractFiles.length; i++) {
        if (this.contractInfo.contractFiles[i].url === url) {
          this.contractInfo.contractFiles.splice(i, 1)
        }
      }
    },
    /* 点击文件列表中已上传的文件时的钩子 */
    handlePreview (file) {
      /* 预览 TODO */
      console.log(file)
      let _width = window.outerWidth
      let _height = window.outerHeight
      window.open(
        file.url,
        '_blank',
        'width=' +
          _width +
          ', height = ' +
          _height +
          ', menubar = no,toolbar = no, status = no, scrollbars = yes'
      )
      // const userAgent = navigator.userAgent
      // if (!!window.ActiveXObject || 'ActiveXObject' in window) {
      //   alert('推荐谷歌进行文件预览')
      // } else {
      //   window.open(file.url) // blob格式地址
      // }
    },
    /* 上传前校验大小限制 */
    beforeAvatarUpload (file) {
      let testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
      const extension = testmsg === 'pdf'
      const isLt2M = file.size / 1024 / 1024 < 20
      /* if(!extension) {
        this.$message({
          message: '上传文件只能是 xls、xlsx格式!',
          type: 'warning'
        });
      } */
      if (!isLt2M) {
        this.$message({
          message: '上传文件大小不能超过 20MB!',
          type: 'warning'
        })
      }
      return extension && isLt2M
    },
    changeCust (val) {
      let params = {}
      let op = {}
      let _this = this
      if (val) {
        op.custId = val
        params.params = op
        _this.$axios
          .get(_this.$API.billmanagement.queryCustContractListByCustId, params)
          .then(function (r) {
            _this.conData = r.data.resData
          })
          .catch(function (error) { console.log(error) })
      } else {
        _this.conData = []
      }
    },
    detail (index, val) {
      this.contractDetailDialog = true
      this.queryEssentialDetail(val.contractId)
      this.queryDetailLog(val.contractId)
      this.queryProductDetail(val.contractId)
    },
    handleEdit (index, val) {
      this.contractDialog = true
      this.add = false
      this.tabDisabled = false
      this.contractInfo.contractId = val.contractId
      this.queryEssential(val.contractId)
      this.queryDetail(val.contractId)
      this.queryProduct(val.contractId)
      this.title = '编辑客户合同'
    },
    queryEssentialDetail (val) {
      let op = {}
      let _this = this
      op.contractId = val
      _this.$axios
        .post(_this.$API.billmanagement.queryCustContractById, op)
        .then(function (r) {
          let data = r.data.resData
          console.log(data)
          _this.contractDetailInfo.sysId = Number(data.sysId)
          _this.contractDetailInfo.custName = data.custId
          _this.contractDetailInfo.numberContract = data.contractCode
          _this.contractDetailInfo.nameContract = data.contractName
          _this.contractDetailInfo.paymentName = data.transferName
          _this.contractDetailInfo.createTime = []
          if (data.contractStart) {
            _this.contractDetailInfo.createTime.push(data.contractStart)
            _this.contractDetailInfo.createTime.push(data.contractEnd)
          }
          _this.contractDetailInfo.contractBalance = data.contractAmount
          _this.contractDetailInfo.transferAmount = data.transferAmount
        })
        .catch(function (error) { console.log(error) })
    },
    queryDetailLog (val) {
      let op = {}
      let _this = this
      op.contractId = val
      _this.$axios
        .post(_this.$API.billmanagement.queryCustContractDetailInfoById, op)
        .then(function (r) {
          let data = r.data.resData
          _this.contractDetailInfo.superContractor = data.custAbuName
          _this.contractDetailInfo.companyContractor = data.abuName
          let contractFiles = []
          if (data.contractFiles.length) {
            for (let v of data.contractFiles) {
              let o = {}
              o.name = v.contractFileName
              o.url = v.contractFileUrl
              contractFiles.push(o)
            }
          }
          _this.contractDetailInfo.contractFiles = contractFiles
        })
        .catch(function (error) { console.log(error) })
    },
    queryProductDetail (val) {
      let op = {}
      let _this = this
      op.contractId = val
      _this.$axios
        .post(_this.$API.billmanagement.queryCustContractRefProdById, op)
        .then(function (r) {
          let data = r.data.resData
          _this.contractDetailInfo.extFieldList = data.prodList
          // _this.calculation()
        })
        .catch(function (error) { console.log(error) })
    },
    queryEssential (val) {
      let op = {}
      let _this = this
      op.contractId = val
      _this.$axios
        .post(_this.$API.billmanagement.queryCustContractById, op)
        .then(function (r) {
          let data = r.data.resData
          console.log(data)
          _this.contractInfo.sysId = Number(data.sysId)
          _this.contractInfo.custName = data.custId
          _this.contractInfo.numberContract = data.contractCode
          _this.contractInfo.nameContract = data.contractName
          _this.contractInfo.paymentName = data.transferName
          _this.contractInfo.createTime = []
          if (data.contractStart) {
            _this.contractInfo.createTime.push(data.contractStart)
            _this.contractInfo.createTime.push(data.contractEnd)
          }
          _this.contractInfo.contractBalance = data.contractAmount
          _this.contractInfo.transferAmount = data.transferAmount
        })
        .catch(function (error) { console.log(error) })
    },
    saveinfoEssential (formName) {
      let _this = this
      this.$refs[formName].validate(valid => {
        if (valid) {
          let op = {}
          let id = this.contractInfo.sysId
          let sysIds = []
          if (id && id !== 0) {
            sysIds.push(id)
          }
          op.sysIds = sysIds
          op.custId = _this.contractInfo.custName
          op.contractCode = _this.contractInfo.numberContract
          op.contractName = _this.contractInfo.nameContract
          op.transferName = _this.contractInfo.paymentName
          op.contractStartTime = _this.contractInfo.createTime ? _this.contractInfo.createTime[0] : ''
          op.contractEndTime = _this.contractInfo.createTime ? _this.contractInfo.createTime[1] : ''
          op.contractAmount = _this.contractInfo.contractBalance
          op.transferAmount = _this.contractInfo.transferAmount
          console.log(op)
          _this.$axios
            .post(_this.$API.billmanagement.addCustContract, op)
            .then(function (r) {
              _this.$message({
                type: 'success',
                message: '新增基本信息成功'
              })
              _this.tabDisabled = false
              _this.contractInfo.contractId = r.data.resData.contractId
            })
            .catch(function (error) { console.log(error) })
        } else {
          _this.$message.error('请按规范填写输入框!')
          return false
        }
      })
    },
    saveinfoEditEssential (formName) {
      let _this = this
      this.$refs[formName].validate(valid => {
        if (valid) {
          let op = {}
          let id = this.contractInfo.sysId
          let sysIds = []
          if (id && id !== 0) {
            sysIds.push(id)
          }
          op.sysIds = sysIds
          op.custId = _this.contractInfo.custName
          op.contractId = _this.contractInfo.contractId
          op.contractCode = _this.contractInfo.numberContract
          op.contractName = _this.contractInfo.nameContract
          op.transferName = _this.contractInfo.paymentName
          op.contractStartTime = _this.contractInfo.createTime ? _this.contractInfo.createTime[0] : ''
          op.contractEndTime = _this.contractInfo.createTime ? _this.contractInfo.createTime[1] : ''
          op.contractAmount = _this.contractInfo.contractBalance
          op.transferAmount = _this.contractInfo.transferAmount
          console.log(op)
          _this.$axios
            .post(_this.$API.billmanagement.updateCustContract, op)
            .then(function (r) {
              _this.$message({
                type: 'success',
                message: '更新基本信息成功'
              })
            })
            .catch(function (error) { console.log(error) })
        } else {
          _this.$message.error('请按规范填写输入框!')
          return false
        }
      })
    },
    queryDetail (val) {
      let op = {}
      let _this = this
      op.contractId = val
      _this.$axios
        .post(_this.$API.billmanagement.queryCustContractDetailInfoById, op)
        .then(function (r) {
          let data = r.data.resData
          _this.contractInfo.superContractor = data.custAbuName
          _this.contractInfo.companyContractor = data.abuName
          let contractFiles = []
          if (data.contractFiles.length) {
            for (let v of data.contractFiles) {
              let o = {}
              o.name = v.contractFileName
              o.url = v.contractFileUrl
              contractFiles.push(o)
            }
          }
          _this.contractInfo.contractFiles = contractFiles
        })
        .catch(function (error) { console.log(error) })
    },
    saveDetail (formName) {
      let _this = this
      this.$refs[formName].validate(valid => {
        if (valid) {
          let op = {}
          op.contractId = _this.contractInfo.contractId
          op.abuName = _this.contractInfo.companyContractor
          op.custAbuName = _this.contractInfo.superContractor
          let contractFiles = []
          for (let v of this.contractInfo.contractFiles) {
            let o = {}
            o.contractFileName = v.name
            o.contractFileUrl = v.url
            contractFiles.push(o)
          }
          op.contractFiles = contractFiles
          console.log(op)
          _this.$axios
            .post(_this.$API.billmanagement.addCustContractDetailInfo, op)
            .then(function (r) {
              if (!_this.add) {
                _this.$message({
                  type: 'success',
                  message: '编辑详细信息成功'
                })
              } else {
                _this.$message({
                  type: 'success',
                  message: '新增详细信息成功'
                })
              }
            })
            .catch(function (error) { console.log(error) })
        } else {
          _this.$message.error('请按规范填写输入框!')
          return false
        }
      })
    },
    queryProduct (val) {
      let op = {}
      let _this = this
      op.contractId = val
      _this.$axios
        .post(_this.$API.billmanagement.queryCustContractRefProdById, op)
        .then(function (r) {
          let data = r.data.resData
          _this.contractInfo.extFieldList = data.prodList
          _this.calculation()
        })
        .catch(function (error) { console.log(error) })
    },
    saveProduct (formName) {
      let _this = this
      this.$refs[formName].validate(valid => {
        if (valid) {
          let op = {}
          op.contractId = _this.contractInfo.contractId
          op.prodList = _this.contractInfo.extFieldList
          for (let i = 0; i < op.prodList.length; i++) {
            if (op.prodList[i] && op.prodList[i + 1] && op.prodList[i].prodId === op.prodList[i + 1].prodId) {
              _this.$message.error('产品不能重复!')
              return
            }
            if (!op.prodList[i].prodId) {
              _this.$message.error('产品不能为空!')
              return
            }
          }
          console.log(op)
          _this.$axios
            .post(_this.$API.billmanagement.addCustContractRefProd, op)
            .then(function (r) {
              if (!_this.add) {
                _this.$message({
                  type: 'success',
                  message: '编辑产品信息成功'
                })
              } else {
                _this.$message({
                  type: 'success',
                  message: '新增产品信息成功'
                })
              }
            })
            .catch(function (error) { console.log(error) })
        } else {
          _this.$message.error('请按规范填写输入框!')
          return false
        }
      })
    },
    closeContract () {
      this.contractInfo = {
        sysId: '',
        cusName: '',
        numberContract: '',
        nameContract: '',
        paymentName: '',
        createTime: '',
        contractBalance: '',
        transferAmount: '',
        contractId: '',
        superContractor: '',
        paymentAmount: '',
        contractFiles: [],
        extFieldList: [],
        companyContractor: ''
      }
      this.query()
      this.tabDisabled = true
      this.activeName = 'first'
      this.$refs['contractInfo'].resetFields() // 关闭时清除验证条件
      this.totalNum = ''
      this.totalPric = ''
      this.title = ''
    },
    closeDeatilContract () {
      this.contractDetailInfo = {
        sysId: '',
        cusName: '',
        numberContract: '',
        nameContract: '',
        paymentName: '',
        createTime: '',
        contractBalance: '',
        transferAmount: '',
        contractId: '',
        superContractor: '',
        paymentAmount: '',
        contractFiles: [],
        extFieldList: [],
        companyContractor: ''
      }
      this.activeDetailName = '99'
    },
    calculation () {
      let num = 0
      for (let v of this.contractInfo.extFieldList) {
        num += v.orderCount
      }
      this.totalNum = num
      let num1 = 0
      for (let v of this.contractInfo.extFieldList) {
        num1 += Number(v.actualOrderAmount)
      }
      this.totalPric = num1
    },
    addNum () {
      this.calculation()
    },
    changePrice () {
      this.calculation()
    },
    changePro (val, index) {
      let _this = this
      val.disabled = false
      for (let v of this.proData) {
        if (v.prodId === val.prodId) {
          _this.contractInfo.extFieldList[index].max = Number(v.stock)
          this.calculation()
        }
      }
    },
    handleAdd () {
      this.contractDialog = true
      this.add = true
      this.tabDisabled = true
      this.title = '新增客户合同'
    },
    contractInfoSave (formName) {
      /* 判断弹窗状态值, 编辑修改/新增保存 */
      let _this = this
      if (this.title === 'editMaintenance') {
        this.$refs[formName].validate(valid => {
          if (valid) {
          } else {
            _this.$message.error('请按规范填写输入框!')
            return false
          }
        })
      } else if (this.title === 'addMaintenance') {
        this.$refs[formName].validate(valid => {
          if (valid) {
          } else {
            _this.$message.error('请按规范填写输入框!')
            return false
          }
        })
      }
    },
    addExtField () {
      this.contractInfo.extFieldList.push({
        prodId: '',
        orderCount: '',
        disabled: true,
        max: 0,
        actualOrderAmount: ''
      })
    },
    /* 删除扩展属性 */
    removeExtField (item) {
      var index = this.contractInfo.extFieldList.indexOf(item)
      if (index !== -1) {
        /* 对已存在的扩展属性删除push到另一个数组 */
        /* if (item.id) {
          item.isDelete = 1
          this.extFieldList2.push(item)
        } */
        this.contractInfo.extFieldList.splice(index, 1)
        this.calculation()
      }
    },
    onSearch () {
      this.page.num = 1
      this.query()
    },
    query () {
      let op = {}
      let _this = this
      let id = this.formInline.sysId
      let sysIds = []
      if (id && id !== 0) {
        sysIds.push(id)
      }
      op.pageNum = this.page.num
      op.pageSize = this.page.sizeSmall
      op.custId = this.formInline.custId
      op.sysIds = sysIds
      op.contractId = this.formInline.conName
      op.startTime = this.formInline.createTime ? this.formInline.createTime[0] + ' 00:00:00' : ''
      op.endTime = this.formInline.createTime ? this.formInline.createTime[1] + ' 23:59:59' : ''
      this.$axios({
        url: _this.$API.billmanagement.queryCustContractListByPage,
        method: 'post',
        data: op
      }).then((response) => {
        console.log(response)
        _this.tableList = response.data.resData.resultList
        _this.totalRows = response.data.resData.pageTotal
      }).catch((err) => {
        console.log(err)
      })
    }
  },
  created () {
    let _this = this
    this.$axios({
      url: _this.$API.rechargeManagement.queryCustSimpleInfoList,
      method: 'post',
      data: {}
    }).then((response) => {
      if (!response.data.resData) return
      _this.cusData = response.data.resData
    }).catch((err) => {
      console.log(err)
    })
    let op = {}
    op.pageNum = 1
    op.pageSize = 0
    this.$axios({
      url: _this.$API.customerManagement.queryHardProdByPage,
      // url: 'http://172.16.9.132:5010/agw/hardProdCtr/queryHardProdByPage',
      method: 'post',
      data: op
    }).then((response) => {
      _this.proData = response.data.resData.resultList
      console.log(_this.proData)
    }).catch((err) => {
      console.log(err)
    })
    this.$store.dispatch('getSystem') // 请求业务系统
    this.query()
  }
}
</script>

<style lang="scss" rel="stylesheet/scss">
</style>



// WEBPACK FOOTER //
// src/views/contractManagement/cusContract.vue